import script from "./de.vue?vue&type=script&lang=js"
export * from "./de.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__